module.exports = "<app-archive-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() archive=$ctrl.archive switch-tab-prefix=app.archive.update> </app-archive-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/update/partial.html
// module id = 398
// module chunks = 0